













import { Vue, Component, Prop } from 'vue-property-decorator'
import GooglePlaySvg from '../../public/static/images/google-play.svg'
import AppStoreSvg from '../../public/static/images/app-store.svg'

@Component({
  components: {
    GooglePlaySvg,
    AppStoreSvg
  }
})

export default class LinksStore extends Vue {
  @Prop() isSmall: boolean
  @Prop() links: any
}
